<h1 color="secondary">Year-end Reflections</h1>
<mat-card appearance="outlined">
    <mat-tab-group backgroundColor="primary" color="primary" *ngIf="plan" [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChanged($event);">
        <mat-tab label="Introduction">
            <ng-template matTabContent>
                <app-year-end-reflections-introduction></app-year-end-reflections-introduction>
            </ng-template>
        </mat-tab>
        <mat-tab *ngFor="let competency of plan?.Competencies; let i = index" [label]="competency?.Name">
            <ng-template matTabContent>
                <app-year-end-reflections-competency [competency]="competency"
                    [finalReflectionStatus]="plan.FinalReflectionStatus"></app-year-end-reflections-competency>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</mat-card>
